import { gql } from '@apollo/client';

const KEY_SCHEDULED_ACTIVITY_SETTINGS = gql`
  fragment BaseKeyScheduledActivitySettings on KeyScheduledActivitySettings {
    activityTypeId
    assessOnLoginDate
    scheduleType
    scheduledDates
  }
`;

export default KEY_SCHEDULED_ACTIVITY_SETTINGS;
